import { useTranslation } from 'react-i18next'

const benefits = ['benefit1', 'benefit2', 'benefit3'] as const

export default function TradeHistoryUpgradeCard() {
  const { t } = useTranslation(['trading'])

  const handleUpgrade = () => {
    window.open('/pricing', '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-50 via-white to-amber-50 border border-orange-200/80 shadow-lg">
      {/* Decorative accent */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-orange-100/50 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-amber-100/40 rounded-full translate-y-1/2 -translate-x-1/2" />

      <div className="relative p-6 md:p-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-semibold mb-4">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              {t('tradeHistoryUpgrade.badge')}
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
              {t('tradeHistoryUpgrade.title')}
            </h3>
            <p className="text-gray-600 text-sm md:text-base mb-4 max-w-lg">
              {t('tradeHistoryUpgrade.description')}
            </p>

            <ul className="space-y-2 mb-6">
              {benefits.map((key) => (
                <li key={key} className="flex items-center gap-2 text-sm text-gray-700">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center">
                    <svg className="w-3.5 h-3.5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </span>
                  {t(`tradeHistoryUpgrade.${key}`)}
                </li>
              ))}
            </ul>

            <button
              onClick={handleUpgrade}
              className="group inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-white bg-orange-500 hover:bg-orange-600 shadow-md hover:shadow-lg transition-all duration-200"
            >
              {t('tradeHistoryUpgrade.cta')}
              <svg className="w-5 h-5 group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>

          <div className="flex-shrink-0 md:w-48">
            <div className="p-4 rounded-xl bg-white/80 border border-orange-100 shadow-sm">
              <p className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">{t('tradeHistoryUpgrade.fromLabel')}</p>
              <p className="text-2xl font-bold text-orange-600">
                $5.99<span className="text-sm font-normal text-gray-500">/mo</span>
              </p>
              <p className="text-xs text-gray-500 mt-1">{t('tradeHistoryUpgrade.trialLabel')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
